module.exports = {
	"config": {
		"linkPrefix": "",
		"name": "request-network-smart-contracts",
		"license": "MIT",
		"version": "0.2.7",
		"description": "Smart contracts that implement the Request Network protocol.",
		"homepage": "https://github.com/RequestNetwork/requestNetwork/tree/master/packages/requestNetworkSmartContracts",
		"buildTime": "2018-10-12T12:07:57.983Z",
		"target": "../docs-smart-contracts",
		"src": "contracts/*",
		"dir": "pages/docs",
		"source": "https://github.com/DigixGlobal/doxity-gatsby-starter-project/archive/a4886b7a7a04c018ac04fed3125d7d4785e74bed.tar.gz",
		"out": "docs",
		"interaction": {}
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs/_template.jsx",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Administrable.json",
				"ext": "json",
				"name": "Administrable",
				"extname": ".json",
				"basename": "Administrable.json",
				"dirname": "docs",
				"stem": "Administrable",
				"path": "docs/Administrable.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/Administrable.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Administrable.json",
			"path": "/docs/Administrable/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "BasicToken.json",
				"ext": "json",
				"name": "BasicToken",
				"extname": ".json",
				"basename": "BasicToken.json",
				"dirname": "docs",
				"stem": "BasicToken",
				"path": "docs/BasicToken.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/BasicToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/BasicToken.json",
			"path": "/docs/BasicToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "BurnableCentralBank.json",
				"ext": "json",
				"name": "BurnableCentralBank",
				"extname": ".json",
				"basename": "BurnableCentralBank.json",
				"dirname": "docs",
				"stem": "BurnableCentralBank",
				"path": "docs/BurnableCentralBank.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/BurnableCentralBank.json",
				"isAbsolute": false
			},
			"requirePath": "docs/BurnableCentralBank.json",
			"path": "/docs/BurnableCentralBank/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "BurnableErc20.json",
				"ext": "json",
				"name": "BurnableErc20",
				"extname": ".json",
				"basename": "BurnableErc20.json",
				"dirname": "docs",
				"stem": "BurnableErc20",
				"path": "docs/BurnableErc20.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/BurnableErc20.json",
				"isAbsolute": false
			},
			"requirePath": "docs/BurnableErc20.json",
			"path": "/docs/BurnableErc20/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Burner.json",
				"ext": "json",
				"name": "Burner",
				"extname": ".json",
				"basename": "Burner.json",
				"dirname": "docs",
				"stem": "Burner",
				"path": "docs/Burner.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/Burner.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Burner.json",
			"path": "/docs/Burner/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Bytes.json",
				"ext": "json",
				"name": "Bytes",
				"extname": ".json",
				"basename": "Bytes.json",
				"dirname": "docs",
				"stem": "Bytes",
				"path": "docs/Bytes.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/Bytes.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Bytes.json",
			"path": "/docs/Bytes/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "BytesUtilsMock.json",
				"ext": "json",
				"name": "BytesUtilsMock",
				"extname": ".json",
				"basename": "BytesUtilsMock.json",
				"dirname": "docs",
				"stem": "BytesUtilsMock",
				"path": "docs/BytesUtilsMock.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/BytesUtilsMock.json",
				"isAbsolute": false
			},
			"requirePath": "docs/BytesUtilsMock.json",
			"path": "/docs/BytesUtilsMock/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "CentralBank.json",
				"ext": "json",
				"name": "CentralBank",
				"extname": ".json",
				"basename": "CentralBank.json",
				"dirname": "docs",
				"stem": "CentralBank",
				"path": "docs/CentralBank.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/CentralBank.json",
				"isAbsolute": false
			},
			"requirePath": "docs/CentralBank.json",
			"path": "/docs/CentralBank/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "CurrencyContract.json",
				"ext": "json",
				"name": "CurrencyContract",
				"extname": ".json",
				"basename": "CurrencyContract.json",
				"dirname": "docs",
				"stem": "CurrencyContract",
				"path": "docs/CurrencyContract.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/CurrencyContract.json",
				"isAbsolute": false
			},
			"requirePath": "docs/CurrencyContract.json",
			"path": "/docs/CurrencyContract/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Destructible.json",
				"ext": "json",
				"name": "Destructible",
				"extname": ".json",
				"basename": "Destructible.json",
				"dirname": "docs",
				"stem": "Destructible",
				"path": "docs/Destructible.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/Destructible.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Destructible.json",
			"path": "/docs/Destructible/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ERC20.json",
				"ext": "json",
				"name": "ERC20",
				"extname": ".json",
				"basename": "ERC20.json",
				"dirname": "docs",
				"stem": "ERC20",
				"path": "docs/ERC20.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/ERC20.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ERC20.json",
			"path": "/docs/ERC20/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ERC20Basic.json",
				"ext": "json",
				"name": "ERC20Basic",
				"extname": ".json",
				"basename": "ERC20Basic.json",
				"dirname": "docs",
				"stem": "ERC20Basic",
				"path": "docs/ERC20Basic.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/ERC20Basic.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ERC20Basic.json",
			"path": "/docs/ERC20Basic/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ERC20OMGLike.json",
				"ext": "json",
				"name": "ERC20OMGLike",
				"extname": ".json",
				"basename": "ERC20OMGLike.json",
				"dirname": "docs",
				"stem": "ERC20OMGLike",
				"path": "docs/ERC20OMGLike.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/ERC20OMGLike.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ERC20OMGLike.json",
			"path": "/docs/ERC20OMGLike/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "FeeCollector.json",
				"ext": "json",
				"name": "FeeCollector",
				"extname": ".json",
				"basename": "FeeCollector.json",
				"dirname": "docs",
				"stem": "FeeCollector",
				"path": "docs/FeeCollector.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/FeeCollector.json",
				"isAbsolute": false
			},
			"requirePath": "docs/FeeCollector.json",
			"path": "/docs/FeeCollector/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "KyberMock.json",
				"ext": "json",
				"name": "KyberMock",
				"extname": ".json",
				"basename": "KyberMock.json",
				"dirname": "docs",
				"stem": "KyberMock",
				"path": "docs/KyberMock.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/KyberMock.json",
				"isAbsolute": false
			},
			"requirePath": "docs/KyberMock.json",
			"path": "/docs/KyberMock/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "KyberNetwork.json",
				"ext": "json",
				"name": "KyberNetwork",
				"extname": ".json",
				"basename": "KyberNetwork.json",
				"dirname": "docs",
				"stem": "KyberNetwork",
				"path": "docs/KyberNetwork.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/KyberNetwork.json",
				"isAbsolute": false
			},
			"requirePath": "docs/KyberNetwork.json",
			"path": "/docs/KyberNetwork/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Migrations.json",
				"ext": "json",
				"name": "Migrations",
				"extname": ".json",
				"basename": "Migrations.json",
				"dirname": "docs",
				"stem": "Migrations",
				"path": "docs/Migrations.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/Migrations.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Migrations.json",
			"path": "/docs/Migrations/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Ownable.json",
				"ext": "json",
				"name": "Ownable",
				"extname": ".json",
				"basename": "Ownable.json",
				"dirname": "docs",
				"stem": "Ownable",
				"path": "docs/Ownable.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/Ownable.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Ownable.json",
			"path": "/docs/Ownable/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Pausable.json",
				"ext": "json",
				"name": "Pausable",
				"extname": ".json",
				"basename": "Pausable.json",
				"dirname": "docs",
				"stem": "Pausable",
				"path": "docs/Pausable.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/Pausable.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Pausable.json",
			"path": "/docs/Pausable/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "RequestBitcoinNodesValidation.json",
				"ext": "json",
				"name": "RequestBitcoinNodesValidation",
				"extname": ".json",
				"basename": "RequestBitcoinNodesValidation.json",
				"dirname": "docs",
				"stem": "RequestBitcoinNodesValidation",
				"path": "docs/RequestBitcoinNodesValidation.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/RequestBitcoinNodesValidation.json",
				"isAbsolute": false
			},
			"requirePath": "docs/RequestBitcoinNodesValidation.json",
			"path": "/docs/RequestBitcoinNodesValidation/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "RequestCore.json",
				"ext": "json",
				"name": "RequestCore",
				"extname": ".json",
				"basename": "RequestCore.json",
				"dirname": "docs",
				"stem": "RequestCore",
				"path": "docs/RequestCore.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/RequestCore.json",
				"isAbsolute": false
			},
			"requirePath": "docs/RequestCore.json",
			"path": "/docs/RequestCore/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "RequestERC20.json",
				"ext": "json",
				"name": "RequestERC20",
				"extname": ".json",
				"basename": "RequestERC20.json",
				"dirname": "docs",
				"stem": "RequestERC20",
				"path": "docs/RequestERC20.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/RequestERC20.json",
				"isAbsolute": false
			},
			"requirePath": "docs/RequestERC20.json",
			"path": "/docs/RequestERC20/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "RequestEthereum.json",
				"ext": "json",
				"name": "RequestEthereum",
				"extname": ".json",
				"basename": "RequestEthereum.json",
				"dirname": "docs",
				"stem": "RequestEthereum",
				"path": "docs/RequestEthereum.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/RequestEthereum.json",
				"isAbsolute": false
			},
			"requirePath": "docs/RequestEthereum.json",
			"path": "/docs/RequestEthereum/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "RequestOMG.json",
				"ext": "json",
				"name": "RequestOMG",
				"extname": ".json",
				"basename": "RequestOMG.json",
				"dirname": "docs",
				"stem": "RequestOMG",
				"path": "docs/RequestOMG.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/RequestOMG.json",
				"isAbsolute": false
			},
			"requirePath": "docs/RequestOMG.json",
			"path": "/docs/RequestOMG/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "SafeMath.json",
				"ext": "json",
				"name": "SafeMath",
				"extname": ".json",
				"basename": "SafeMath.json",
				"dirname": "docs",
				"stem": "SafeMath",
				"path": "docs/SafeMath.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/SafeMath.json",
				"isAbsolute": false
			},
			"requirePath": "docs/SafeMath.json",
			"path": "/docs/SafeMath/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "SafeMathInt.json",
				"ext": "json",
				"name": "SafeMathInt",
				"extname": ".json",
				"basename": "SafeMathInt.json",
				"dirname": "docs",
				"stem": "SafeMathInt",
				"path": "docs/SafeMathInt.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/SafeMathInt.json",
				"isAbsolute": false
			},
			"requirePath": "docs/SafeMathInt.json",
			"path": "/docs/SafeMathInt/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "SafeMathIntMock.json",
				"ext": "json",
				"name": "SafeMathIntMock",
				"extname": ".json",
				"basename": "SafeMathIntMock.json",
				"dirname": "docs",
				"stem": "SafeMathIntMock",
				"path": "docs/SafeMathIntMock.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/SafeMathIntMock.json",
				"isAbsolute": false
			},
			"requirePath": "docs/SafeMathIntMock.json",
			"path": "/docs/SafeMathIntMock/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "SafeMathUint8.json",
				"ext": "json",
				"name": "SafeMathUint8",
				"extname": ".json",
				"basename": "SafeMathUint8.json",
				"dirname": "docs",
				"stem": "SafeMathUint8",
				"path": "docs/SafeMathUint8.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/SafeMathUint8.json",
				"isAbsolute": false
			},
			"requirePath": "docs/SafeMathUint8.json",
			"path": "/docs/SafeMathUint8/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "SafeMathUint96.json",
				"ext": "json",
				"name": "SafeMathUint96",
				"extname": ".json",
				"basename": "SafeMathUint96.json",
				"dirname": "docs",
				"stem": "SafeMathUint96",
				"path": "docs/SafeMathUint96.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/SafeMathUint96.json",
				"isAbsolute": false
			},
			"requirePath": "docs/SafeMathUint96.json",
			"path": "/docs/SafeMathUint96/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Signature.json",
				"ext": "json",
				"name": "Signature",
				"extname": ".json",
				"basename": "Signature.json",
				"dirname": "docs",
				"stem": "Signature",
				"path": "docs/Signature.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/Signature.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Signature.json",
			"path": "/docs/Signature/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "StandardToken.json",
				"ext": "json",
				"name": "StandardToken",
				"extname": ".json",
				"basename": "StandardToken.json",
				"dirname": "docs",
				"stem": "StandardToken",
				"path": "docs/StandardToken.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/StandardToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/StandardToken.json",
			"path": "/docs/StandardToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TestRequestPaymentStuckAssert.json",
				"ext": "json",
				"name": "TestRequestPaymentStuckAssert",
				"extname": ".json",
				"basename": "TestRequestPaymentStuckAssert.json",
				"dirname": "docs",
				"stem": "TestRequestPaymentStuckAssert",
				"path": "docs/TestRequestPaymentStuckAssert.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/TestRequestPaymentStuckAssert.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TestRequestPaymentStuckAssert.json",
			"path": "/docs/TestRequestPaymentStuckAssert/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TestRequestPaymentStuckNonPayable.json",
				"ext": "json",
				"name": "TestRequestPaymentStuckNonPayable",
				"extname": ".json",
				"basename": "TestRequestPaymentStuckNonPayable.json",
				"dirname": "docs",
				"stem": "TestRequestPaymentStuckNonPayable",
				"path": "docs/TestRequestPaymentStuckNonPayable.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/TestRequestPaymentStuckNonPayable.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TestRequestPaymentStuckNonPayable.json",
			"path": "/docs/TestRequestPaymentStuckNonPayable/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TestRequestPaymentStuckRevert.json",
				"ext": "json",
				"name": "TestRequestPaymentStuckRevert",
				"extname": ".json",
				"basename": "TestRequestPaymentStuckRevert.json",
				"dirname": "docs",
				"stem": "TestRequestPaymentStuckRevert",
				"path": "docs/TestRequestPaymentStuckRevert.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/TestRequestPaymentStuckRevert.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TestRequestPaymentStuckRevert.json",
			"path": "/docs/TestRequestPaymentStuckRevert/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TestToken.json",
				"ext": "json",
				"name": "TestToken",
				"extname": ".json",
				"basename": "TestToken.json",
				"dirname": "docs",
				"stem": "TestToken",
				"path": "docs/TestToken.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/TestToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TestToken.json",
			"path": "/docs/TestToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TestTokenOMGLike.json",
				"ext": "json",
				"name": "TestTokenOMGLike",
				"extname": ".json",
				"basename": "TestTokenOMGLike.json",
				"dirname": "docs",
				"stem": "TestTokenOMGLike",
				"path": "docs/TestTokenOMGLike.json",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/docs/TestTokenOMGLike.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TestTokenOMGLike.json",
			"path": "/docs/TestTokenOMGLike/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md",
				"absolute": "/Users/travis/build/RequestNetwork/requestNetwork-private/packages/docs-smart-contracts/index.md",
				"isAbsolute": false
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 386
// module chunks = 0